const ACCESS_TOKEN_KEY = 'mDo7fVhH1uXP50GLhf';
const REFRESH_TOKEN_KEY = 'NYks3AnZSdMTbc5pOy';
const IMPERSONATING_KEY = '45881f327ea4';
const USER_KEY = 'user';
var ROLE;
(function (ROLE) {
    ROLE[ROLE["ANONYMOUS"] = 0] = "ANONYMOUS";
    ROLE[ROLE["USER"] = 1] = "USER";
})(ROLE || (ROLE = {}));
var REQUEST_TOKEN;
(function (REQUEST_TOKEN) {
    REQUEST_TOKEN[REQUEST_TOKEN["ANONYMOUS"] = 0] = "ANONYMOUS";
    REQUEST_TOKEN[REQUEST_TOKEN["OPTIONAL"] = 1] = "OPTIONAL";
    REQUEST_TOKEN[REQUEST_TOKEN["SECURE"] = 2] = "SECURE";
})(REQUEST_TOKEN || (REQUEST_TOKEN = {}));
const SECURE_CONFIG_PARAM_VARIANTS = [REQUEST_TOKEN.OPTIONAL, REQUEST_TOKEN.SECURE];
export { ACCESS_TOKEN_KEY, IMPERSONATING_KEY, REFRESH_TOKEN_KEY, ROLE, USER_KEY, REQUEST_TOKEN, SECURE_CONFIG_PARAM_VARIANTS, };
//# sourceMappingURL=auth.js.map